import { SortableElement, SortableHandle } from 'react-sortable-hoc'
import { useTranslation } from 'react-i18next'

import { Form, FlexRow, Icon } from '@/ui'

interface HandleProps {
  disabled: boolean
}
const Handle = SortableHandle<HandleProps>((disabled: boolean) => (
  <Icon.Drag
    disabled={disabled}
    className="handle"
    style={{ float: 'right', left: 0 }}
  />
))

interface OptionProps {
  value: string
  error?: string | boolean
  checked?: boolean
  isPredefined?: boolean
  init?: boolean
  type?: string
  sortable?: boolean
  options?: any[]
  disabledInput?: boolean
  disabledCheckbox?: boolean
  checkboxLabel?: string
  handleChange?: (e: any, data: any, isPredefined?: any) => void
  handleBlur?: (e: any, data: any, isPredefined?: any) => void
  handleCheckboxChange: (checked: boolean, value: string) => void
  handleDelete: (i: string) => void
  disableRemove: (i: string) => boolean
  useToggle?: boolean
  predefinedOptions?: any[]
}

const Option = SortableElement<OptionProps>(
  ({
    value,
    error,
    checked,
    isPredefined,
    init,
    type,
    sortable,
    options,
    disabledInput,
    disabledCheckbox,
    checkboxLabel,
    handleChange,
    handleBlur,
    handleCheckboxChange,
    handleDelete,
    disableRemove,
    useToggle,
    predefinedOptions,
  }: OptionProps) => {
    const { t } = useTranslation()

    if (predefinedOptions && !init) {
      return <div />
    }

    const InputComponent = (() => {
      if (isPredefined || type === 'select') {
        return (
          <Form.Dropdown
            fluid
            search
            selection
            error={error}
            disabled={disabledInput}
            style={{ width: '100%' }}
            placeholder={t('Select')}
            options={
              isPredefined ? predefinedOptions : options?.filter(x => !!x)
            }
            value={value}
            onChange={isPredefined ? handleBlur : handleChange}
          />
        )
      }

      return (
        <Form.Input
          fluid
          error={error}
          disabled={disabledInput || isPredefined}
          style={{ width: '100%' }}
          placeholder={t('Value')}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      )
    })()

    return (
      <FlexRow noMargin={!init} alignItems="center">
        {sortable && (
          <FlexRow.Section>
            {init && !disabledInput && <Handle disabled={!!disabledInput} />}
          </FlexRow.Section>
        )}

        <FlexRow.Section flex="30">
          <div style={{ width: '100%' }}>{InputComponent}</div>
        </FlexRow.Section>

        {!!checkboxLabel && checkboxLabel.length && init && !disabledInput && (
          <FlexRow.Section
            justifyContent="flex-end"
            style={{ margin: '0 .5rem' }}>
            <Form.Checkbox
              toggle={useToggle}
              disabled={disabledCheckbox}
              checked={checked}
              label={checkboxLabel}
              onChange={(e, { checked }) => {
                handleCheckboxChange(!!checked, value)
              }}
            />
          </FlexRow.Section>
        )}

        {!disabledInput && (init || !checkboxLabel) && (
          <FlexRow.Section justifyContent="flex-end">
            {init && !disableRemove(value) && (
              <Icon.Delete value={value} onClick={() => handleDelete(value)} />
            )}
          </FlexRow.Section>
        )}
      </FlexRow>
    )
  },
)

export default Option
